import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/eng/item-flows`;

export const flowApi = {
  meta: () => axios.get(`${API}/meta`).then((r) => r.data),
  list: (params) => axios.get(API, { params }).then((r) => r.data),
  create: (b) => axios.post(API, b).then((r) => r.data),
  get: (fid) => axios.get(`${API}/${fid}`).then((r) => r.data),
  patch: (fid, b) => axios.patch(`${API}/${fid}`, b).then((r) => r.data),
  addComponent: (fid, b) => axios.post(`${API}/${fid}/components`, b).then((r) => r.data),
  componentAction: (fid, cid, b) => axios.post(`${API}/${fid}/components/${cid}/action`, b).then((r) => r.data),
  createOutput: (fid, b) => axios.post(`${API}/${fid}/outputs`, b).then((r) => r.data),
  outcome: (fid, oid, b) => axios.post(`${API}/${fid}/outputs/${oid}/outcome`, b).then((r) => r.data),
  close: (fid, confirm) => axios.post(`${API}/${fid}/close`, { confirm }).then((r) => r.data),
  reopen: (fid) => axios.post(`${API}/${fid}/reopen`).then((r) => r.data),
  addPhoto: (fid, b) => axios.post(`${API}/${fid}/photos`, b).then((r) => r.data),
  deletePhoto: (fid, pid) => axios.delete(`${API}/${fid}/photos/${pid}`).then((r) => r.data),
};
